//import { AngularMaterialModules, SharedModule } from '../shared/shared.module';
import {NgModule} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {DashboardsRoutingModule} from './dashboards-routing.module';
import {ChartsModule} from 'ng2-charts';
import {AdminDashboardComponent} from './admin-dashboard/admin-dashboard.component';
import {AssistedDashboardComponent} from './assisted-dashboard/assisted-dashboard.component';
import {AdminDashboardService} from './admin-dashboard/admin-dashboard.service';
import {BillerDashboardComponent} from './biller-dashboard/biller-dashboard.component';
import {BillerDashboardService} from './biller-dashboard/biller-dashboard.service';
import {BankDashboardComponent} from './bank-dashboard/bank-dashboard.component';
import {BankDashboardService} from './bank-dashboard/bank-dashboard.service';
import {UserRouteAccessService} from '../shared/auth/user-route-access-service';
import {GrsAdminDashboardComponent} from './grs-admin-dashboard/grs-admin-dashboard.component';
import {GrsDashboardService} from './grs-admin-dashboard/grs-dashboard.service';
import {HttpClient} from '../../../node_modules/@angular/common/http';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {AssistedDashboardService} from './assisted-dashboard/assisted-dashboard.service';

import {
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatExpansionModule,
  MatFormFieldModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
} from '@angular/material';
import {FormsModule} from '../../../node_modules/@angular/forms';
import {SharedModule} from '../shared/shared.module';
import {ReconcilliationDashboardComponent} from './reconcilliation-dashboard/reconcilliation-dashboard.component';
import {GatewayDashboardService} from './reconcilliation-dashboard/gateway-dashboard.service';
import {CustomDashboardComponent} from './custom-dashboard/custom-dashboard.component';
import {BlankDashboardComponent} from './blank-dashboard/blank-dashboard.component';
import {DashboardService} from './dashboard.service';
import { AppModule } from '../app.module';
import { DateFilterComponent } from '../date-filter/date-filter.component';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, 'i18n/dashboard/', '.json');
}

@NgModule({
  imports: [
    //AngularMaterialModules,
    SharedModule,
    CommonModule,
    FormsModule,
    DashboardsRoutingModule,
    ChartsModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatFormFieldModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
      isolate: true,
    }),
  ],
  providers: [
    AdminDashboardService,
    DashboardService,
    BillerDashboardService,
    BankDashboardService,
    UserRouteAccessService,
    GrsDashboardService,
    DatePipe,
    GatewayDashboardService,
    AssistedDashboardService,
  ],
  declarations: [
    AdminDashboardComponent,
    BillerDashboardComponent,
    BankDashboardComponent,
    GrsAdminDashboardComponent,
    ReconcilliationDashboardComponent,
    CustomDashboardComponent,
    AssistedDashboardComponent,
    BlankDashboardComponent,
    DateFilterComponent,
  ],
  exports: [AssistedDashboardComponent],
})
export class DashboardsModule {}



// WEBPACK FOOTER //
// ./src/app/dashboards/dashboards.module.ts